import apiClient from '../client';
import type { DashboardStats, MonthlySummary, PayrollAlert, TaskDueAlert } from '../../types';

const normalizeNumber = (value: unknown) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }
  return 0;
};

export const getDashboardStats = async (): Promise<DashboardStats> => {
  const response = await apiClient.get<Partial<DashboardStats>>('/dashboard/stats');
  return {
    activeProjects: normalizeNumber(response.data.activeProjects),
    totalPayments: normalizeNumber(response.data.totalPayments),
    activeStaff: normalizeNumber(response.data.activeStaff),
    pendingRequests: normalizeNumber(response.data.pendingRequests),
    activeFarmOperations: normalizeNumber(response.data.activeFarmOperations),
    pendingExpenses: normalizeNumber(response.data.pendingExpenses),
    totalRevenue: normalizeNumber(response.data.totalRevenue),
    totalCost: normalizeNumber(response.data.totalCost),
    netProfit: normalizeNumber(response.data.netProfit),
    roiPercent: normalizeNumber(response.data.roiPercent),
    cultivatedAcres: normalizeNumber(response.data.cultivatedAcres),
  };
};

export const getMonthlySummary = async (): Promise<MonthlySummary> => {
  const response = await apiClient.get<Partial<MonthlySummary>>('/dashboard/monthly-summary');
  return {
    totalExpenses: normalizeNumber(response.data.totalExpenses),
    salaryPayments: normalizeNumber(response.data.salaryPayments),
    contractorFees: normalizeNumber(response.data.contractorFees),
    otherExpenses: normalizeNumber(response.data.otherExpenses),
    periodLabel: response.data.periodLabel ?? 'This Month',
  };
};

export const getPayrollAlerts = async (): Promise<PayrollAlert[]> => {
  const response = await apiClient.get<PayrollAlert[]>('/dashboard/payroll-alerts');
  return response.data;
};

export const getTaskDueAlerts = async (): Promise<TaskDueAlert[]> => {
  const response = await apiClient.get<TaskDueAlert[]>('/dashboard/task-alerts');
  return response.data;
};

const dashboardService = {
  getDashboardStats,
  getMonthlySummary,
  getPayrollAlerts,
  getTaskDueAlerts,
};

export default dashboardService;
